<template>
    <a-modal 
        v-model="visible" 
        :title="$t('table.widgetsCenter')" 
        width="900px"
        :footer="null"
        @cancel="closeModal"
    >
        <div class="widgets-center">
            <div class="categories">
                <h3>{{ $t('chatbotv2.categories') }}</h3>
                <ul class="category-list">
                    <li class="category-item active">
                        <a href="javascript:;">{{ $t('tables.suggested') }}</a>
                    </li>
                    <li class="category-item d-none">
                        <a href="javascript:;">{{ $t('table.stayUpdated') }}</a>
                    </li>
                    <li class="category-item d-none">
                        <a href="javascript:;">{{ $t('table.motivation') }}</a>
                    </li>
                    <li class="category-item d-none">
                        <a href="javascript:;">{{ $t('table.media') }}</a>
                    </li>
                    <li class="category-item d-none">
                        <a href="javascript:;">{{ $t('table.personal') }}</a>
                    </li>
                    <li class="category-item d-none">
                        <a href="javascript:;">{{ $t('table.supsisApps') }}</a>
                    </li>
                    <li class="category-item d-none">
                        <a href="javascript:;">{{ $t('table.marketplaceApps') }}</a>
                    </li>
                </ul>
            </div>
            <div class="widgets-container">
                <h2>{{ $t('tables.suggested') }}</h2>
                <div class="widgets-grid">
                    <!-- Chart Widget -->
                    <div class="widget-card">
                        <div class="widget-image">
                            <img src="/static/img/tables/chart.png" :alt="$t('tables.graph')" />
                        </div>
                        <h3 class="widget-title">{{ $t("tables.graph") }}</h3>
                        <p class="widget-description">{{ $t("tables.graphDesc") }}</p>
                        <a-button type="primary" class="add-widget-btn" @click="selectWidgetType('chart')">{{ $t("tables.addWidget") }}</a-button>
                    </div>
                    
                    <!-- Numbers Widget -->
                    <div class="widget-card">
                        <div class="widget-image">
                            <img src="/static/img/tables/numbers.png" :alt="$t('tables.numbers')" />
                        </div>
                        <h3 class="widget-title">{{ $t("tables.numbers") }}</h3>
                        <p class="widget-description">{{ $t("tables.numbersDesc") }}</p>
                        <a-button type="primary" class="add-widget-btn" @click="selectWidgetType('numbers')">{{ $t("tables.addWidget") }}</a-button>
                    </div>
                    
                    <!-- Text Widget -->
                    <div class="widget-card">
                        <div class="widget-image">
                            <img src="/static/img/tables/text.png" :alt="$t('message.text')" />
                        </div>
                        <h3 class="widget-title">{{ $t("message.text") }}</h3>
                        <p class="widget-description">{{ $t("tables.textDesc") }}</p>
                        <a-button type="primary" class="add-widget-btn" @click="selectWidgetType('text')">{{ $t("tables.addWidget") }}</a-button>
                    </div>
                    
                    <!-- Countdown Widget -->
                    <div class="widget-card">
                        <div class="widget-image">
                            <img src="/static/img/tables/countdown.png" :alt="$t('table.countdownWidget')" />
                        </div>
                        <h3 class="widget-title">{{ $t("tables.countdown") }}</h3>
                        <p class="widget-description">{{ $t("tables.countdownDesc") }}</p>
                        <a-button type="primary" class="add-widget-btn" @click="selectWidgetType('countdown')">{{ $t("tables.addWidget") }}</a-button>
                    </div>
                    
                    <!-- Iframe Widget -->
                    <div class="widget-card">
                        <div class="widget-image">
                            <img src="/static/img/tables/iframe.png" :alt="$t('table.iframeWidget')" />
                        </div>
                        <h3 class="widget-title">{{ $t('table.iframeWidget') }}</h3>
                        <p class="widget-description">{{ $t('tables.iframeDesc') }}</p>
                        <a-button type="primary" class="add-widget-btn" @click="selectWidgetType('iframe')">{{ $t("tables.addWidget") }}</a-button>
                    </div>
                    
                    <!-- Youtube Widget -->
                    <div class="widget-card">
                        <div class="widget-image">
                            <img src="/static/img/tables/youtube.png" :alt="$t('table.youtubeWidget')" />
                        </div>
                        <h3 class="widget-title">{{ $t('table.youtubeWidget') }}</h3>
                        <p class="widget-description">{{ $t('tables.youtubeDesc') }}</p>
                        <a-button type="primary" class="add-widget-btn" @click="selectWidgetType('youtube')">{{ $t("tables.addWidget") }}</a-button>
                    </div>
                    
                    <!-- Gantt Widget -->
                    <div class="widget-card">
                        <div class="widget-image">
                            <img src="/static/img/tables/gantt.png" :alt="$t('table.ganttWidget')" />
                        </div>
                        <h3 class="widget-title">{{ $t('table.ganttWidget') }}</h3>
                        <p class="widget-description">{{ $t('table.visualizeTasksOnTimeline') }}</p>
                        <a-button type="primary" class="add-widget-btn" @click="selectWidgetType('gantt')">{{ $t("tables.addWidget") }}</a-button>
                    </div>
                    
                    <!-- Pivot Widget -->
                    <div class="widget-card">
                        <div class="widget-image">
                            <img src="/static/img/tables/pivot.svg" :alt="$t('table.pivotWidget')" />
                        </div>
                        <h3 class="widget-title">{{ $t('table.pivotWidget') }}</h3>
                        <p class="widget-description">{{ $t('table.analyzePivotTable') }}</p>
                        <a-button type="primary" class="add-widget-btn" @click="selectWidgetType('pivot')">{{ $t("tables.addWidget") }}</a-button>
                    </div>
                </div>
            </div>
        </div>
    </a-modal>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "WidgetCenter",
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        closeModal() {
            this.$emit('close');
        },
        selectWidgetType(type) {
            this.$emit('widget-type-selected', type);
        }
    }
});
</script>

<style lang="scss" scoped>
.widgets-center {
    display: flex;
    flex-direction: row;
    align-items: flex-start;

    .categories {
        width: 200px;
        padding-right: 20px;
        border-right: 1px solid #e8e8e8;
        margin-right: 20px;
        
        h3 {
            margin-bottom: 15px;
            font-size: 16px;
            font-weight: 600;
            color: #333;
        }
        
        .category-list {
            list-style: none;
            padding: 0;
            margin: 0;
            display: flex;
            flex-direction: column;
            gap: 8px;
            
            .category-item {
                a {
                    display: block;
                    text-decoration: none;
                    color: #666;
                    padding: 8px 12px;
                    border-radius: 4px;
                    font-size: 14px;
                    transition: all 0.3s ease;
                    
                    &:hover {
                        background-color: #f5f5f5;
                        color: #1890ff;
                    }
                }
                
                &.active a {
                    background-color: #e6f7ff;
                    color: #1890ff;
                    font-weight: 500;
                }
            }
        }
    }

    .widgets-container {
        flex: 1;
        
        h2 {
            margin-bottom: 20px;
            font-size: 18px;
            font-weight: 600;
            color: #333;
        }
        
        .widgets-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 20px;
            
            .widget-card {
                border: 1px solid #e8e8e8;
                border-radius: 8px;
                padding: 16px;
                transition: all 0.3s ease;
                
                &:hover {
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
                    transform: translateY(-2px);
                }
                
                .widget-image {
                    margin-bottom: 16px;
                    height: 120px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: #f5f5f5;
                    border-radius: 6px;
                    overflow: hidden;
                    
                    img {
                        max-width: 100%;
                        max-height: 100%;
                        object-fit: contain;
                    }
                }
                
                .widget-title {
                    margin-bottom: 8px;
                    font-size: 16px;
                    font-weight: 600;
                    color: #333;
                }
                
                .widget-description {
                    margin-bottom: 16px;
                    font-size: 14px;
                    color: #666;
                    line-height: 1.5;
                    height: 60px;
                    overflow: hidden;
                }
                
                .add-widget-btn {
                    width: 100%;
                }
            }
        }
    }
}
</style> 